<script setup lang="ts">
/** On Board — DR: Change of Director (선임/사임 반복 결의 + [[Signers]]). */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import OnBoardLoopBlock from './OnBoardLoopBlock.vue';
import OnBoardIncludeToggle from './OnBoardIncludeToggle.vue';
import './onboardDoc.css';

const APPT_COLS = [
  { key: 'director_name', label: 'Name' },
  { key: 'director_identification_no', label: 'Identification No.' },
  { key: 'effective_date', label: 'Effective Date' },
];
</script>

<template>
  <div class="agm-doc">
    <OnBoardIncludeToggle flag="include_dr_director" />
    <div class="doc-head">
      <div class="doc-title"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-sub">Company Registration No. <CddVarField field-key="company_registration_no" label="Reg. No." /></div>
      <div class="doc-sub">(Incorporated in the Republic of Singapore)</div>
      <div class="doc-sub">(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="sec-title center">DIRECTORS' RESOLUTIONS IN WRITING</div>
    <div class="doc-p center">PASSED PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">APPOINTMENT OF DIRECTOR</div>
    <p class="doc-p">
      RESOLVED that each of the following persons, having consented to act, be and is hereby appointed a
      director of the Company with effect from the respective effective date:
    </p>
    <div class="doc-p doc-note">Incoming director(s). Rows from a Form 45 (Consent to Act as Director) are linked automatically; you can also add an incoming director here without a Form 45.</div>
    <!-- Form 45 연동 행(자동) + 직접 추가 행(appt_dir_m). 예전엔 Form 45 를 추가해야만 선임 행이 생겨 고객이 입력할 곳을 못 찾았다. -->
    <OnBoardLoopBlock prefix="appt_dir" :columns="APPT_COLS" :show-add="false" :show-remove="false" hide-empty />
    <OnBoardLoopBlock prefix="appt_dir_m" :columns="APPT_COLS" add-label="+ Add incoming (appointed) director" hide-empty />
    <p class="doc-p">RESOLVED that the Accounting and Corporate Regulatory Authority be notified accordingly.</p>

    <div class="sec-title">RESIGNATION OF DIRECTOR</div>
    <p class="doc-p">
      RESOLVED that the resignation of each of the following persons as a director of the Company be accepted
      as from the respective effective date:
    </p>
    <div class="doc-p doc-note">Outgoing director(s). Use ✨ on the name to pick a current director.</div>
    <OnBoardLoopBlock prefix="resign_dir" :columns="APPT_COLS" add-label="+ Add outgoing (resigning) director"
      empty-note="No director resignation." />
    <p class="doc-p">RESOLVED that the Accounting and Corporate Regulatory Authority be notified accordingly.</p>

    <div class="doc-meta">Dated: <CddVarField field-key="dr_resolution_date" label="Resolution Date" /></div>
    <AgmSigners var-key="dr_director_Signers" board-label="Directors" />
    <div class="doc-sub">(Incoming)</div>
  </div>
</template>
